import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withMemo as _withMemo, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5ecc5d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-book-open" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  ref: "content",
  class: "content"
}
const _hoisted_4 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_ManualModal = _resolveComponent("ManualModal")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Connect = _resolveComponent("Connect")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("header", {
          class: "header",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.headerClick()))
        }, [
          _withMemo([_ctx.$t(_ctx.$route.name as string)], () => (_openBlock(), _createElementBlock("span", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.$route.name as string)), 1)
          ])), _cache, 0),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "btn version-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showManual = true))
            }, _hoisted_2),
            (_ctx.btsTracker.isConnected())
              ? (_openBlock(), _createBlock(_component_ManualModal, {
                  key: 0,
                  visible: _ctx.showManual,
                  section: _ctx.$t(_ctx.$route.name as string),
                  onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showManual = false))
                }, null, 8, ["visible", "section"]))
              : (_openBlock(), _createBlock(_component_ManualModal, {
                  key: 1,
                  visible: _ctx.showManual,
                  section: _ctx.$t('connection'),
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showManual = false))
                }, null, 8, ["visible", "section"]))
          ])
        ], 512), [
          [_vShow, _ctx.$i18next.isInitialized]
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_ctx.$route.name === 'header.settings' || _ctx.btsTracker.connected)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { ref: "content1" }, null, 512))
              ], 1024))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createBlock(_KeepAlive, null, [
        _createVNode(_component_Connect)
      ], 1536)), [
        [_vShow, _ctx.$route.name !== 'header.settings' && !_ctx.btsTracker.connected]
      ])
    ], 512), [
      [_vShow, _ctx.$i18next.isInitialized]
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _withMemo([_ctx.$t(_ctx.$route.name as string)], () => _createVNode(_component_Footer), _cache, 5)
        ], 512), [
          [_vShow, _ctx.$i18next.isInitialized]
        ])
      ]),
      _: 1
    })
  ], 64))
}